<template>
  <div class="page_users">
    <h1>Uživatelé</h1>
    <div class="actions">
      <input v-model="newName" class="name" type="text" placeholder="Jméno" title="Jméno" />
      <input v-model="newEmail" class="email" type="text" placeholder="E-mail" title="E-mail" />
      <input v-model="newPassword" class="password" type="text" placeholder="Heslo" title="Heslo" />
      <dropdown :items="userRoles" @change="change">
        <template v-slot:label>{{ userRoles[newRole] | cz }}</template>
        <template v-slot:item="props">{{ props.item | cz }}</template>
      </dropdown>
      <template v-if="userId != null">
        <button @click="changePassword" class="changePassword" title="Změnit heslo">
          <i class="fa fa-key"></i>
        </button>
        <button @click="cancelPassword" class="cancelPassword" title="Zrušit změnu hesla">
          <i class="fa fa-times"></i>
        </button>
      </template>
      <button v-else @click="create" class="add" title="Nový uživatel">
        <i class="fa fa-plus"></i>
      </button>
    </div>
    <tabloid name="users" :columns="columns" :data="users">
      <template v-slot:name="{ row }">
        <inputer :paths="['users', row.id, 'name']" :required="true" />
      </template>
      <template v-slot:role="{ row }">
        <inputerSelect :paths="['users', row.id, 'role']" :items="userRoles">
          <template v-slot:default="props">{{ props.item | cz }}</template>
          <template v-slot:item="props">{{ props.item | cz }}</template>
        </inputerSelect>
      </template>
      <template v-slot:email="{ row }">
        <inputer :paths="['users', row.id, 'email']" :required="true" />
      </template>
      <template v-slot:phone="{ row }">
        <inputer :paths="['users', row.id, 'phone']" />
      </template>
      <template v-slot:actions="{ row }">
        <button @click="selectUser(row)" class="selectUser" title="Změnit heslo">
          <i class="fa fa-key"></i>
        </button>
        <button @click="remove(row)" class="remove" title="Odstranit uživatele">
          <i class="fa fa-times"></i>
        </button>
      </template>
    </tabloid>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { data } from "../../store_utils";
import { _ } from "../../extend";
import tabloid from "../../components/tabloid.vue";
import inputer from "../../components/inputer";
import inputerSelect from "../../components/inputer-select";
import dropdown from "../../components/dropdown";

export default {
  name: "users",
  components: {
    tabloid,
    inputer,
    inputerSelect,
    dropdown,
},
  data: () => ({
    userId: null,
    newName: "",
    newRole: 0,
    newEmail: "",
    newPassword: "",
    columns: {
      name: { title: "Jméno" },
      role: { title: "Role" },
      email: { title: "E-mail" },
      phone: { title: "Telefon" },
      actions: { title: " " },
    },
  }),
  computed: {
    ...mapState(["users", "userRoles"])
  },
  methods: {
    change(role, roleId) {
      this.newRole = roleId;
    },
    create() {
      this.$store.dispatch("createUser", {
        name: this.newName,
        email: this.newEmail,
        password: this.newPassword,
        role: this.newRole
      });

      this.newName = "";
      this.newEmail = "";
      this.generatePassword();
    },
    selectUser(user) {
      this.userId = user.id;

      this.newName = user.name;
      this.newRole = user.role == "User" ? 0 : 1;
      this.newEmail = user.email;
      this.newPassword = "";
    },
    changePassword() {
      if (this.userId == null || this.newPassword == null)
        return;

      if (this.newPassword.length < 4) {
        this.$store.commit("notify", { text: "Heslo je příliš krátké", level: "warning" });
        return;
      }

      this.$store.dispatch("adminChangePassword", { userId: this.userId, newPassword: this.newPassword });
      this.cancelPassword();
    },
    cancelPassword() {
      this.userId = null;

      this.newName = "";
      this.newRole = 0;
      this.newEmail = "";
      this.newPassword = "";
    },
    remove(user) {
      if (_.any(this.$store.state.outposts, outpost => outpost.leaderId == user.id)) {
        this.$store.commit("notify", {
          level: "warning",
          text: "Nelze smazat uživatele, který má přiřazenou hlídku!"
        });
        return;
      }
      if (!confirm(`Opravdu chcete odebrat uživatele ${user.name}?`)) return;

      this.$store.commit("remove", {
        paths: ["users", user.id]
      });
    },
    generatePassword() {
      this.newPassword = `${data.randomHex()}${data.randomHex()}`;
    }
  },
  mounted() {
    this.generatePassword();
  }
};
</script>

<style lang="sass">
@import ../../sass/_components

.page_users
  @include table-view()
  .actions
    input
      @include input-base()
    .name
      @include first-input()
    .email, .password, div.label
      @include middle-input()
    button.changePassword
      @include button-warning()
      @include middle-input()
    button.cancelPassword
      @include button-danger()
      @include last-input()
    button.add
      @include last-input()
  .selectUser
    @include button-warning()
    @include first-input()
  .remove
    @include button-danger()
    @include last-input()
</style>
